<template>
  <div class="mt-2 mb-2">
    <span v-if="task.discarded">
      <span class="font-weight-light" v-html="generateTelLinks(notesContent())" placeholder="Add notes here..." style="white-space: pre-line;"></span>
    </span>
    <span v-else>
      <span v-if="editing">
        <textarea-autosize ref="notesinput" class="form-control" v-model="notesText" @blur.native="blur" @focus="focus" placeholder="Add notes here..."></textarea-autosize>
      </span>
      <span v-else>
        <span class="font-weight-light" v-html="generateTelLinks(notesContent())" v-on:click.self="focus" style="white-space: pre-line;"></span>
      </span>
    </span>
  </div>
</template>

<script>
import api from "api";

export default {
  props: {
    task: {
      type: Object
    },
    containerExpanded: {
      type: Boolean
    }
  },
  data() {
    return {
      editing: false,
      notesText: this.task.notes
    };
  },
  watch: {
    containerExpanded(){
      if(!this.containerExpanded){
        this.saveNotes();
        this.editing = false
      } else {
        this.editing = true
      }
    }
  },
  methods: {
    notesContent(){
      return this.notesText || "Add notes here..."
    },
    saveNotes(){
      this.editing = false;
      if(this.notesText != this.task.notes){
        api.updateTask(this.task.id, { notes: this.notesText }).then(response => {
        });
      }

    },
    blur(){
      this.saveNotes()
    },
    focus(){
      this.editing = true;
    }
  }
}
</script>
